var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.8970097 7.7137065c-.7079876 0-1.2818147-.5740383-1.2818147-1.282026 0-.7077764.5738271-1.28181473 1.2818147-1.28181473.7079877 0 1.2818148.57403833 1.2818148 1.28181473 0 .7079877-.5738271 1.282026-1.2818148 1.282026zm-3.6709297 0c-.7079877 0-1.2818147-.5740383-1.2818147-1.282026 0-.7077764.573827-1.28181473 1.2818147-1.28181473.7077764 0 1.2818147.57403833 1.2818147 1.28181473 0 .7079877-.5740383 1.282026-1.2818147 1.282026zm-3.6711411 0c-.7079876 0-1.2818147-.5740383-1.2818147-1.282026 0-.7077764.5738271-1.28181473 1.2818147-1.28181473.7079877 0 1.2818148.57403833 1.2818148 1.28181473 0 .7079877-.5738271 1.282026-1.2818148 1.282026zm10.8970098-1.144485c0-3.62825188-3.2350663-6.56922121-7.2258687-6.56922121C3.2352775 2.9e-7 0 2.94096962 0 6.5692215c0 3.6280406 3.2352775 6.5692213 7.22608 6.5692213.3836782 0 .7578489-.0352832 1.1254701-.0876798l3.2306294 1.9492373.2860685-3.3996507c1.5786582-1.2051213 2.5837007-3.0106906 2.5837007-5.0311281z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.68f569fbaf87c962236af15a25460082.svg";
export { ForwardRef as ReactComponent };